'use client'

import type { UseQuantitySelectorProps } from '@pearlconvert/ui/components/quantity-selector/quantity-selector.types'

import { useEffect, useState } from 'react'

export const useQuantitySelector = (props: UseQuantitySelectorProps) => {
  const { value, blurFallback, onChange } = props
  const [displayValue, setDisplayValue] = useState(String(value))

  useEffect(() => {
    setDisplayValue(String(value))
  }, [value])

  const handleChange = (raw: string) => {
    setDisplayValue(raw.replace(/\D+/g, ''))
  }

  const handleBlur = () => {
    const parsed = Number(displayValue)
    const committed = onChange(parsed || blurFallback)
    setDisplayValue(String(committed))
  }

  const decrement = () => setDisplayValue(String(onChange(value - 1)))
  const increment = () => setDisplayValue(String(onChange(value + 1)))

  return {
    displayValue,
    handleChange,
    handleBlur,
    decrement,
    increment,
  }
}
